<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Boombinere Payment Bridge</h4>
  <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
    (click)="activeModal.close('false')">
  </button>
</div>
<div class="modal-body">
  <div *ngIf="!paymentSubmitted" class="row justify-content-center">
    <div class="col-sm-10">
      <div class="card mb-2">
        <div class="card-body pb-1">
          <table class="table table-sm table-striped">
            <thead class="thead-dark">
              <tr>
                <th colspan="2">Breakdown of charge(s)</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let charge of chargeList">
                <tr *ngIf="charge.value" title="{{ charge.desc }}">
                  <td>{{ charge.key }}</td>
                  <td>{{ charge.value | currency }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div *ngIf="recipient" class="col-sm-8">
      <div class="card mb-2">
        <div class="card-body pb-1">
          <table class="table table-sm table-bordered">
            <thead class="thead-dark">
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>City</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ recipient?.name }}</td>
                <td>{{ recipient?.phone }}</td>
                <td>{{ recipient?.city }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div *ngIf="returnaddress" class="col-sm-8">
      <table>
        <thead>
          <tr>
            <th>Address</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ returnaddress }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-8">
      <div class="card mb-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <table class="table table-sm">
                <thead class="thead-light">
                  <tr>
                    <th colspan="2">Payment Methods</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let paymentOption of paymentOptions"
                    [ngStyle]="{'opacity':  (paymentOption.id == 12 && type != 'shipping') ? '0.4' : '1'}">
                    <td><img [src]="cloudfronturl+paymentOption.logoPath"
                        (click)="selectPaymentMethod(paymentOption.id)"></td>
                    <td style="vertical-align: middle;">
                      <label class="radio radio-success">
                        <input type="radio" name="radio" [disabled]="paymentOption.id == 12 && type != 'shipping'"
                          value="{{paymentOption.id}}" [checked]="paymentOption.id == selectedPaymentOption"
                          (change)="selectPaymentMethod(paymentOption.id)">
                        <span class="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-6">
              <div class="d-flex flex-column justify-content-end h-100">
                <div class="w-100">
                  <btn-loading btnClass="btn-success w-100 mb-1" *ngIf="selectedPaymentOption != 12" [loading]="loading"
                    [loadingText]="loadingText" [type]="'button'" (click)="submitPayment()">
                    Pay Now ({{ finalCost | currency }})
                  </btn-loading>
                  <btn-loading btnClass="btn-success w-100 mb-1" *ngIf="selectedPaymentOption == 12" [loading]="loading"
                    [loadingText]="loadingText" (click)="submitPaymentForCod()">
                    Submit ({{ finalCost | currency }})
                  </btn-loading>
                </div>
                <div class="w-100">
                  <a href="javascript:" class="btn-link text-small" *ngIf="selectedPaymentOption != 12"
                    (click)="openTAC(modalTAC)">By clicking "Pay Now" you
                    agree to our Terms and Conditions</a>
                  <a href="javascript:" class="btn-link text-small" *ngIf="selectedPaymentOption == 12"
                    (click)="openTAC(modalTAC)">By clicking "Submit" you
                    agree to our Terms and Conditions</a>
                  <p class="text-danger mt-1 text-center text-small" *ngIf="submitted && !selectedPaymentOption">
                    Select a Payment Option
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="paymentSubmitted && authorizeSubmitted" style="width:90%;max-width: 1000px">
    <iframe name="iframeAuthorizeNet" #iframeAuthorizeNet id="iframeAuthorizeNet"
      style="width:100%;max-width: 1000px; height: 550px;">
    </iframe>

    <form method="post" #authorizeNetForm target="iframeAuthorizeNet" action="{{ authorizeNetEndPoint }}"
      id="formAuthorizeNetTestPage" name="formAuthorizeNetTestPage">
      <input type="hidden" name="token" value="{{ authorizeNetToken }}" />
    </form>
  </div>
  <div *ngIf="paymentSubmitted && !authorizeSubmitted" class="row justify-content-center h-auto">
    <div class="col-sm-12 text-center mb-5 mt-5">
      <div class="spinner spinner-warning p-5"></div>
      <h3>Please wait, you are redirecting to payment provider page.</h3>
    </div>
  </div>
  <form method="post" #paypalForm name="paypalForm" action="{{ paypalEndPoint }}">
    <input type="hidden" name="cmd" value="_xclick">
    <input type="hidden" name="business" value="{{ paypalBusinessAccount }}">
    <input type="hidden" name="currency_code" value="USD">
    <input type="hidden" name="on0" value="{{ serviceType }}">
    <input type="hidden" name="os0" value="{{ paymentId }}">
    <input type="hidden" name="return" value="{{ apiBaseUrl }}/payment/pdtvalidate">
    <input type="hidden" name="cancel_return" value="{{ websiteUrl }}">
    <input type="hidden" name="notify_url" value="{{ apiBaseUrl }}/payment/ipnvalidate">
    <input type="hidden" name="item_name" value="{{ service }}">
    <input type="hidden" name="amount" value="{{ totalAmount }}">
    <input type="hidden" name="custom" value="{{ paymentId }}">
    <input type="hidden" name="no_shipping" value="1">
    <input type="submit" style="display: none;" id="submitButton" value="CLICK HERE">
  </form>
  <ng-template #modalTAC let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Terms of Service</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      </button>
    </div>
    <div class="modal-body" style="height: 300px; overflow-y: auto;">
      <p><em>All services provided by Boombinere LLC (&ldquo;Boombinere&rdquo;) are governed under these Terms and
          Conditions of Service and are subject to change at any time.</em></p>
      <p>&nbsp;</p>
      <p><strong>DEFINITION</strong></p>
      <p>As used herein, the following words shall have the following respective meanings</p>
      <ul>
        <li>&ldquo;You&rdquo; or &ldquo;your&rdquo; means the person or entity using Boombinere&rsquo;s services as
          described in these Terms and Conditions and on Boombinere&rsquo;s website,&nbsp;<a target="_blank"
            href="https://boombinere.com/">com</a>, including any agents, employees or representatives thereof.</li>
        <li>&ldquo;Shipment&rdquo; means one or more packages shipped from one point of origin at one time consigned for
          delivery to one destination.</li>
      </ul>
      <p>&nbsp;</p>
      <p><strong>ACKNOWLEDGMENT AND ACCEPTANCE OF TERMS OF SERVICE</strong></p>
      <p>The services offered by Boombinere LLC (&ldquo;Boombinere&rdquo;) at&nbsp;<a target="_blank"
          href="https://boombinere.com/">www.boombinere.com&nbsp;</a>(&ldquo;Boombinere.com&rdquo; or
        &ldquo;Site&rdquo;), and any sub-domains, are provided to you under these Terms and Conditions of Service
        (&ldquo;Terms of Service&rdquo;), and any operating rules or policies that may be published by Boombinere at the
        URL:&nbsp;<a target="_blank" href="https://boombinere.com/">www.boombinere.com</a>&nbsp;(the
        &ldquo;Service&rdquo;). These Terms of Service comprises the entire agreement between you and Boombinere, and
        supersedes all prior agreements between the parties regarding the subject matter contained herein. BY COMPLETING
        THE REGISTRATION PROCESS, OR USING Boombinere.com, YOU AGREE TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS
        HEREIN. You may continue to use Boombinere.com as long as you adhere to these Terms of Service.</p>
      <p>&nbsp;</p>
      <p><strong>EXPORT COMPLIANCE</strong></p>
      <p>Boombinere and the Web Site are based in the United States. The United States and certain other jurisdictions
        control the export of products and information. You agree to comply with all such applicable restrictions and
        not to export or re-export the Content (including any software or the Services) to countries or persons
        prohibited under the United States or other applicable export control laws or regulations. If you access and
        download the Content (including any software or the Services) or Information, You represent that You are not in
        a country where such export is prohibited or are not a person or entity to which such export is prohibited. You
        are solely responsible for compliance with the laws of Your local jurisdiction and any other applicable laws
        regarding the import, export, or re-export of the Content (including any software or the Services).</p>
      <p><strong>ACCEPTANCE</strong></p>
      <p>Boombinere will not accept &ldquo;postage due&rdquo; mail and/or COD packages, items or parcels on behalf of
        Customer unless Customer has previously arranged and prepaid such acceptance with Boombinere. At its sole
        discretion, Boombinere may refuse to accept &ldquo;postage due&rdquo; mail and/or COD packages, items or parcels
        on behalf of Customer under any circumstances.</p>
      <p>Customer further acknowledges that Boombinere may return to sender or discard any mail that is received at such
        mailing address but is addressed to a name not previously registered with Boombinere or is addressed to a name
        that has not completed the requirements set forth by Boombinere to verify the identity of such name, or is
        shipped by USPS from the Vendor to a name for which Boombinere has not received a properly executed USPS Form
        1583 and two forms of identification.</p>
      <p><strong>INSPECTION</strong></p>
      <p>Boombinere reserves the right to open and inspect all items delivered in your name without notice to you.
        Boombinere takes every precaution and makes every effort to fully comply with all laws and regulations governing
        international trade, including the Federal Trade Statistics Regulations (FTSR). By using our service, you agree
        to abide by guidelines that deem certain goods unacceptable (and thus unshippable). Goods can be unshippable
        if:&nbsp;they are classified as hazardous, dangerous, prohibited, or restricted by IATA (International Air
        Transport Association), ICAO (International Civil&nbsp;Aviation Organization), or any other relevant
        organization; or we can&rsquo;t safely or legally ship them. If we receive products we can&rsquo;t ship, we will
        reach&nbsp;out to you. We have the right to refuse any product we feel is unsuitable to ship, even if it is
        legal.</p>
      <p>The following list is a non-exclusive sampling of items that are either restricted, cannot be shipped or,
        depending on your destination country, may either require an import license, additional documentation and/or
        cause problems and delays during the customs review of your shipment:</p>
      <ul>
        <li>Combustible/flammable items (paints, oils, lighters)</li>
        <li>Any type of pressurized can (hair spray, shaving cream, spray cans of any type)</li>
        <li>Hazardous materials (matches, chemicals, explosives)</li>
        <li>Firearms, weaponry and their parts: military, police and tactical equipment of any kind, includingguns, gun
          replicas, gun accessories, gun components (magazines, clips and rail systems), ammunition, knives, swords,
          compound bows, crossbows, discharge weapons such as shock batons or stun guns, tooling for guns or gun parts,
          optical scopes, laser sights, night sights, night visions goggles, handcuffs and other restraints,
          surveillance equipment.</li>
        <li>Agricultural products such as tobacco, plants and seeds.</li>
        <li>Coffee</li>
        <li>Perishable foods</li>
        <li>Animals and products made with animal skin (furs)</li>
        <li>Alcohol</li>
        <li>Cash, currency, money orders, cashiers&rsquo; checks, bank drafts, bearer bonds and collectible stampsand
          coins. Jewelry and precious stones are (a) restricted to some countries and (b) can only be insured up to $500
          maximum and any shipments of jewelry in excess of $500 carriage limit is uninsured and Member assumes all risk
          of loss above such limit</li>
        <li>Lottery tickets and gambling devices</li>
        <li>Prescription and/or veterinary medication</li>
        <li>Pornography</li>
        <li>Lock picking devices</li>
        <li>Government IDs and licenses, or items that claim to be, or that look similar to, government identification
          documents. This includes uniforms and badges or patches designed to look like official Government Issue.</li>
      </ul>
      <p>&nbsp;</p>
      <p>A full list of prohibited items can be viewed&nbsp;<a target="_blank"
          href="https://boombinere.com/prohibited-items/">HERE</a>!</p>
      <p>&nbsp;</p>
      <p><strong>STORAGE</strong></p>
      <p>Boombinere can store each item free of charge for a period of 60 days from the date of delivery. The maximum
        free storage time for each package is 60 days since the date of its delivery to your suite. After 60 days of
        free storage, Boombinere will charge you a fee of $0.50 per pound per day for an additional 30 days, which must
        be paid prior to shipping said item. After 90 days in storage, Boombinere reserves the right to sell, destroy or
        otherwise dispose of such items without incurring any liability from you or any other party whatsoever.</p>
      <p><strong>INSURANCE POLICY</strong></p>
      <p>All claims for lost or damaged items within your insured package must be reported to Boombinere at the time of
        pickup. Otherwise they will be automatically denied. Packages are insured by Boombinere&rsquo;s private
        insurance. Insurance for packages lost in our U.S. warehouse or lost during the shipping covers only the value
        entered in the customs declaration. You have to be able to prove value entered by invoice or order. If you claim
        lower value in customs declaration that is what you get paid. You have to support insurance claims for lost or
        damaged items with a proof that those items were really received at our warehouse and were in good condition.
        The best way is to request pictures of your incoming items.</p>
      <p>Insurance cost is 3% of the value of the item. For example, if you want to insure a package for $1000, the
        insurance cost will be $30. Claims will only be paid out for individual items that are damaged or missing and
        can take up to 21 days to investigate.. You must inspect packages within the confinements of Boombinere branches
        prior to signing the packing list for package acceptance. If any items that are insured are missing or damage,
        you must file a claim at that time of pickup.</p>
      <p>You must sign the packing list at the time of pickup to accept your package. Once the packing list is signed by
        you, you shall defend, indemnify, and hold Boombinere and its employees and agents harmless from and against all
        claims, liabilities, losses, damages, fines, penalties, payments, costs, and expenses related to your package.
      </p>
      <p>&nbsp;</p>
      <p><strong>DUTIES AND TAXES</strong></p>
      <p>Boombinere only collects duties and taxes on certain electronics upon shipping, but in the event your package
        requires substantial duties and taxes to be paid to the destination country, this will be on your
        responsibility. If Customer refuses to accept packages or parcels from Boombinere mailed or forwarded to
        Customer pursuant to this AGREEMENT, Boombinere may return the mail or package to the original sender and charge
        the Customer for any return postage and all other fees and expenses reasonably incurred by Boombinere in
        connection with such returns. Upon the request of Boombinere, the Customer must sign for or otherwise
        acknowledge its acceptance of all packages and parcels sent to Customer by Boombinere.</p>
      <p>Boombinere includes basic order descriptions and values with the customer shipment(s), to facilitate custom
        clearance of packages when they arrive to the destination country. The customer is however responsible of paying
        all duties and taxes to his country and of providing detailed commercial invoices, if requested, to the customs
        office in his country, to clear his package(s) through customs for delivery.</p>
      <p><strong>DIMENSIONAL WEIGHT</strong></p>
      <p>Dimensional weight may apply on bulky, lightweight packages. If the dimensional weight exceeds the actual
        weight, then the dimensional weight will be used as the billable weight for the shipment. For your convenience,
        the actual weight, dimensional weight and dimensions for each box will be visible on your account when your
        package arrives at our warehouse. For more information about the dimensional weight, please visit
        http://en.wikipedia.org/wiki/Dimensional_weight</p>
      <p><strong>RETAILERS WHO DON&rsquo;T SHIP TO FREIGHT FORWARDERS:</strong></p>
      <p>Unfortunately, some retailers choose not to ship to freight forwarders. Although nothing about our operation is
        illegal, it is their right to refuse sending their products. These retailers may include Best Buy, Apple,
        Sephora, Ulta, Adidas, Lego and others.</p>
      <p><strong>PACKAGE RETURNS</strong></p>
      <p>Boombinere provides a returns service in the event you would like to return an item in your inbox back to the
        seller or company for a refund. You can create a return request from your online account and the cost is $5 plus
        the cost of postage. Once a return package is picked up by a carrier (UPS, USPS, FEDEX, etc), Boombinere will
        not responsible for packages that are damaged or lost in transit to the recipient of the package. In the event
        your return package is lost or damaged in transit, you can file a claim directly with the carrier (UPS, USPS,
        FEDEX, etc).</p>
      <p><strong>VERIFYING INFORMATION</strong></p>
      <p>In order to ensure your safety, you may need to verify your information. Information we may ask for includes
        legal documentation such as a driver&rsquo;s&nbsp;license, passport, and/or other forms of identification.</p>
      <p><strong>LIABILITY</strong></p>
      <p>All Packages are shipped on a limited liability basis. In no event shall Boombinere be liable to anyone for any
        indirect, punitive, special, exemplary, incidental, consequential or other damages of any type or kind. In no
        event shall Boombinere be liable to anyone for any direct damages of any type or kind (including lost profits)
        from performance of the Boombinere Service.</p>
      <p>The Shipping calculator shows results for the discounted shipping rates available to the selected destination.
        All shipping rates are shown in US dollars.<br /> The discounted shipping rates displayed on Boombinere.com and
        on any of its pages, are confidential and intended solely for the addressee(s) and may be legally privileged or
        prohibited from disclosure. If you are not the named addressee, you are on notice of its status and may not use
        copy or disclose this information to any other person. To do so could be a breach of confidence and unlawful.
      </p>
      <p>&nbsp;</p>
      <p><strong>USER CONDUCT</strong></p>
      <p>Your use of the Service is subject to all applicable local, state, national and international laws and
        regulations, including but not limited to all U.S. postal regulations, and all regulations set forth by foreign
        jurisdictions through which you are shipping.</p>
      <p>If you use this site, you are responsible for maintaining the confidentiality of your account and password and
        for restricting access to your computer, and you agree to accept responsibility for all activities that occur
        under your account or password. Boombinere reserves the right to refuse service, terminate accounts, remove or
        edit content, or cancel orders at their sole discretion.</p>
      <p>Customer will enter a confidential password and receive a US address with his own unit number when registering
        for a new account with Boombinere. Customer shall maintain the security and confidentiality of the password.
        Customer is responsible for all directions, orders, notifications, expenses incurred or other actions that may
        occur through use of the Customer&rsquo;s account. Customer must immediately alert Boombinere of any fraudulent,
        unauthorized, illegal or suspicious use of the Service or any other breach of security or unauthorized or
        illegal activity that is reasonably suspected by Customer.</p>
      <p>For the protection of our customer&rsquo;s accounts, we do not allow the change of the country on the
        forwarding address. The forwarding address can only be modified to another address within the same country that
        the customer selected during his registration on Boombinere.com, and must be requested by sending a message to
        our customer service from the same email address used at the registration on Boombinere. Forwarding to other
        Freight Forwarding companies inside or outside the United States is absolutely not permitted.</p>
      <p>&nbsp;</p>
      <p>Most of the activity at the Site involves the viewing of materials, which are made accessible to everyone so
        there is no need for it to be secure. Other areas of the Site require the use of passwords, usernames and may
        have other security features. You are responsible to keep your usernames and passwords confidential. You should
        promptly notify Boombinere if you become aware of unauthorized use of your usernames or passwords or use of
        services or materials available from this Site. The use of your usernames or passwords by you, or by any person
        with or without your knowledge or consent, in connection with a Boombinere transaction, binds you legally and
        makes you responsible to the same extent and effect as if you had given signed, written instructions to us,
        unless you have previously notified us that the confidentiality of your usernames or passwords has been
        compromised.</p>
      <ul>
        <li>Harm or threaten to harm Boombinere or users in any way, including by using information you find here to
          compete against Boombinere;</li>
        <li>Impersonate any person or entity (including Boombinere or its agent), or falsely state or otherwise
          misrepresent your affiliation with a person or entity;</li>
        <li>Disseminate or transmit any content that infringes or violates any party&rsquo;s copyright, trademark, trade
          secret, patent or other rights;</li>
        <li>Violate any law (whether local, state, national, or international), whether or not intentionally;</li>
        <li>Forge Internet protocol headers or otherwise manipulate identifying information in order to disguise your
          identity;</li>
        <li>Provide fraudulent, inaccurate, or incomplete information to Boombinere or any shipping service or
          government agency;</li>
        <li>Interfere with or disrupt the Services, the Site, or servers or networks connected to the Site, or disobey
          any requirements, procedures, policies, or regulations of networks connected to the Site;</li>
        <li>Collect or store personal data about other users;</li>
        <li>Engage in any activities that would violate the personal privacy rights of others, including but not limited
          to, collecting and distributing information about Internet users without their permission, except as permitted
          by applicable law;</li>
        <li>or post or cause to be uploaded to Boombinere computer servers or network any material that contains
          software viruses or any other computer code, files, or programs designed to interrupt, destroy, or limit the
          functionality of any computer software or hardware or telecommunications equipment.</li>
      </ul>
      <p>&nbsp;</p>
      <p><strong>FRAUD</strong></p>
      <p>If you are suspected of fraud &ndash; either by us, or an outside party &ndash; we reserve the right to protect
        ourselves from knowingly aiding fraudulent activity.&nbsp;If this happens, we may: hold any items in our
        warehouse until you can prove you purchased them legally; temporarily or permanently suspend your&nbsp;account;
        or perform any other action we deem necessary, with or without your permission.</p>
      <p><strong>WEBSITE / APPLICATION ACCEPTANCE</strong></p>
      <p>This site and/or application is provided by Boombinere on an &lsquo;as is&rsquo; and &lsquo;as available&rsquo;
        basis. Boombinere makes no representations or warranties of any kind, express or implied, as to the operation of
        this site and/or application or the information, content, materials or products included on this site. You
        expressly agree that your use of this site and/or application is at your sole risk. To the full extent
        permissible by applicable law, Boombinere disclaims all warranties, express or implied, including, but not
        limited to, implied warranties of merchantability and fitness for a particular purpose. Boombinere does not
        warrant that this site, application, its servers or e-mail sent from Boombinere are free of viruses or other
        harmful components. Boombinere will not be liable for any damages of any kind arising from the use of this site
        and/or application, including, but not limited to, direct, indirect, incidental, punitive and consequential
        damages. Certain state laws do no allow limitations on implied warranties or the exclusion or limitation of
        certain damages. If these laws apply to you, some or all of the above disclaimers, exclusions or limitations may
        not apply to you and you might have additional rights.</p>
      <p>All contents included on the Boombinere web site, such as text, graphics, icons, logos, button icons, images,
        audio clips, digital downloads, data compilations, and software, is the property of Boombinere or its content
        suppliers and protected by United States and International Copyright Laws. The compilation of all content on
        this site is the exclusive property of Boombinere and protected by US and International Copyright Laws. All
        software used on this site is the property of Boombinere or its software suppliers and protected by United
        States and International Copyright Laws. All right, title, and interest in the web site and services provided
        therein, including, but not limited to, all associated market data and information is owned by Boombinere, and
        you acquire no interest therein. All rights reserved. Any unauthorized use or any reproduction, modification, or
        distribution of materials is strictly prohibited. All other trademarks or trade dress not owned by Boombinere
        that appear on this site are the property of their respective owners, who may or may not be affiliated with,
        connected to, or sponsored by Boombinere.</p>
      <p><strong>COOKIES</strong></p>
      <p>&ldquo;Cookies&rdquo; are pieces of information that a web site transfers to your computer&rsquo;s hard disk so
        that your computer can be identified when you re-access the site. A cookie can only be read by the site that
        places it, so Boombinere cannot track information based on any other cookies in your browser. From time to time,
        we may use the cookie feature of web browser applications, which will allow us to store data about your visit.
        Cookies help us to provide you with a customized web experience and to learn which areas of our site are useful
        and which areas need improvement. We may also use cookies to provide you with shopping fulfillment services,
        including requests for price quotations, purchase instructions, purchase tracking, and the administration of
        special promotions. Internet Explorer uses a separate file for each cookie. Cookies are generally supported in
        version 3.0 and newer of Internet Explorer. Most browsers also allow the option of displaying a warning before
        accepting a cookie, or refusing all cookies. Declining cookies while using Boombinere shopping cart may result
        in some features not working properly.</p>
      <p><strong>PRIVACY POLICY</strong></p>
      <p>The Boombinere Privacy Policy governs the use of information collected from or provided by you at the Web Site.
        With respect to any individual whose personal information is provided by you to Boombinere, you represent to
        Boombinere that you have obtained all necessary consents for the processing of such personal information
        contemplated by the services you are using and by the Boombinere Privacy Policy, including the transfer of such
        data to the United States or other countries whose laws may not provide the</p>
      <p>same level of protection for the personal data as the laws of the country of origin of such individual.</p>
      <p><strong>LINKED SITES</strong></p>
      <p>The links to other websites will let you leave Boombinere site. The linked sites are not under the control of
        Boombinere and Boombinere is not responsible for the contents of any linked site or any link contained in a
        linked site, or any changes or updates to such sites. Boombinere is providing these links to you only as a
        convenience, and the inclusion of any link does not imply endorsement or any representation by Boombinere of the
        site. It is up to you to take precautions to ensure that whatever you select for your use is free of such items
        as viruses, bugs, problems or other limitations.</p>
      <p><strong>TERMS OF SERVICE MODIFICATIONS</strong></p>
      <p>Boombinere may modify any aspect of this agreement at any time at its sole discretion without prior notice. Any
        modification to the Terms and Conditions shall be effective immediately once posted on the web site. Check the
        web site regularly if you are interested in reviewing any changes. Your use of the web site and the Boombinere
        service after modifications have been posted constitutes your acknowledgment of such modifications and your
        agreement to be bound by the terms and conditions of these changes.</p>
      <p><strong>ACCOUNT CLOSURE</strong></p>
      <p>You may close your account with or without cause at any time. Boombinere may terminate your use of the Service
        with or without cause at any time and effective immediately, at Boombinere&rsquo;s sole discretion, should your
        conduct fail to conform to the terms and conditions of these Terms of Service. Boombinere shall not be liable to
        you or any third party for termination of the Service or termination of your use of the Service. Should you
        object to any terms and conditions of the Terms of Service or any subsequent modifications Boombinere makes to
        the Terms of Service or become dissatisfied with the Service in any way, your only recourse is to immediately:
        (1) discontinue use of the Service; and (2) notify Boombinere of your termination and, at your discretion,
        notify Boombinere of the reasons for your termination.</p>
      <p>You agree that Boombinere, in its sole discretion, may terminate or suspend Your use of the Web Site, the
        Boombinere Systems, Information, Services and Content at any time and for any or no reason in its sole
        discretion, even if access and use continues to be allowed to others. Upon such suspension or termination, you
        must immediately (a) discontinue use of the Web Site, and (b) destroy any copies you have made of any portion of
        the Content. Accessing the Web Site, the Boombinere Systems, Information or Services after such termination,
        suspension or discontinuation shall constitute an act of trespass. Further, You agree that Boombinere shall not
        be liable to you or any third party for any termination or suspension of your access to the Web Site, the
        Boombinere Systems, Information and/or the Services.</p>
      <p><strong>ACTS OF GOD, ETC</strong></p>
      <p>You agree to use the Web Site in strict compliance with all applicable laws, rulings and regulations and in a
        fashion that does not, in the sole judgment of Boombinere, negatively reflect on the goodwill or reputation of
        Boombinere and shall take no actions which would cause Boombinere to be in violation of any laws, rulings or
        regulations applicable to Boombinere.</p>
      <p>Boombinere shall be excused from performance of its obligations, in whole or in part, under this Agreement if
        the failure or inability to perform is caused by reason of Force Majeure. &ldquo;Force Majeure&rdquo; as used
        herein means acts of God, fire, flood or other natural catastrophes, electric, communications or other utility
        outages, national emergencies, civil disturbances, insurrections, riots, wars (declared or undeclared),
        epidemics, strikes or labor disputes, actions or restrictions of an governmental authority, or causes not within
        the reasonable control of Boombinere.</p>
      <p><strong>ASSIGNMENT/WAIVERS</strong></p>
      <p>You may not assign these Terms of Use or any of your interests, rights or obligations under these Terms of Use.
        If any provision of these Terms of Use is found to be invalid by any court having competent jurisdiction, the
        invalidity of such provision shall not affect the validity of the remaining provisions of these Terms of Use,
        which shall remain in full force and effect. No waiver of any of these Terms of Use shall be deemed a further or
        continuing waiver of such term or condition or any other term or condition.</p>
      <p>&nbsp;</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark btn-rounded" (click)="modal.close('Save click')">Close</button>
    </div>
  </ng-template>
  <ng-template #modalCODTAC let-codmodal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-cod-title">Cash on Delivery Terms &amp; Conditions</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="codmodal.dismiss('Cross click')">
      </button>
    </div>
    <div class="modal-body" style="height: 300px; overflow-y: auto;">
      <p style="font-weight: 300;">The availability of Cash on Delivery for shipments made on Boombinere.com (the
        "Site") is subject to the Cash on Delivery terms &amp; conditions below which are separate from and in addition
        to the Conditions of Use that govern your use of the Site, including each package that you ship.</p>
      <p style="font-weight: 300;">&nbsp;</p>
      <ul style="font-weight: 300;">
        <li>Cash on Delivery can be used as payment method only for orders shipped to Erbil branch.</li>
        <li>Cash on Delivery can be used as payment method only for shipments less than $250 USD. You can request to
          increase your Cash on Delivery limit by emailing&nbsp;<a
            href="mailto:info@boombinere.com">info@boombinere.com</a>. We will review your account history and will
          notify you with our decision.</li>
        <li>Boombinere will add a 3% fee ($3 minimum) for all Cash on Delivery shipments.</li>
        <li>Shipments paid using Cash on Delivery will be billed in U.S. dollars but may be paid in the local currency
          of the destination country at the applicable exchange rate.</li>
        <li>The shipment amount set forth on your shipment confirmation must be paid in full before receiving your items
          and signing the delivery sheet. The package can be opened and your items inspected only after the payment is
          made.</li>
        <li>We reserve the right to make changes to Cash on Delivery, our policies, and these terms and conditions at
          any time. You will be subject to the policies and terms and conditions in force at the time that you use Cash
          on Delivery, unless any change to those policies or these conditions is required to be made by law or
          government authority (in which case it will apply to shipments previously requested by you). If any of these
          conditions is deemed invalid, void, or for any reason unenforceable by a court, that condition will be deemed
          severable and will not affect the validity and enforceability of any remaining condition.</li>
      </ul>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark btn-rounded" (click)="codmodal.close('Save click')">Close</button>
    </div>
  </ng-template>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary btn-rounded"
    (click)="activeModal.close('false')">Cancel</button>
</div>

